import React from 'react';
import loadable from '@loadable/component';
import Spinner from '@components/common/Spinner';

export default (asyncComp, opts = {}) => loadable(asyncComp, {
  fallback: opts.fallback || <Spinner {...opts.fallbackProps || {}} />,
  ssr: false,
});
